import { Box } from '@mui/material'
import PredictionInterval from './PredictionInterval'
import Prediction from './Prediction'
import { PadithiEnum, PredictionType } from '../../../utils/enums'

const PredictionCard = ({ prediction, filter, user }) => {

    const { predictionType, conditionType } = filter;

    const isShowInterval = ![PadithiEnum.MASTER, PadithiEnum.LAL_KITAB].includes(conditionType) || predictionType === PredictionType.DAY;

    if (conditionType === PadithiEnum.MASTER) return null;

    return (
        <Box sx={{ mb: 3 }}>

            <Box sx={{ pl: 2 }}>
                <Box key={prediction._id} sx={{ mb: 1.5 }}>

                    {isShowInterval && (
                        <PredictionInterval
                            intervals={prediction?.intervals}
                            user={user}
                            filter={filter}
                        />
                    )}

                    <Prediction prediction={prediction} />
                </Box>
            </Box>
        </Box>
    )
}

export default PredictionCard
